<template>
<div class="container">
    <van-tabs color="#2283E2" :active="active" @click="tabGetList">
        <van-tab :title="item.name" v-for="(item,index) in cards" :name="item.sts" :key="index">
            <van-list :loading="loading" :finished="complated" :total="total" finished-text="没有更多了" @load="onLoad">
                <div class="cardlist" v-for="(item,index) in cardList" :key="index">
                    <div class="tit">实体卡id：{{item.cardNo}}</div>
                    <div class="tit">兑换商品：{{item.goodsName}}</div>
                    <div class="tit">激活日期：{{item.activeTime}}</div>
                    <div class="tit">商品积分：{{item.scoreSrice}}</div>
                    <!-- <van-button v-if="item.sts==2" round plain color="#2283E2" type="primary" @click="submit(index)">下单</van-button> -->
                    <div style="border:1px #2283E2 solid;" class="gopay" @click="submit(index)" v-if="item.sts==2">下单</div>
                </div>
            </van-list>
        </van-tab>

    </van-tabs>
</div>
</template>

<script>
import {
    getUserPointCard
} from '@/api/api'
export default {
    data() {
        return {
            pageNum: 1,
            total: "",
            complated: false,
            loading: false,
            finished: false,
            active: "",
            cardList: [],
            cards: [{
                    name: "已激活",
                    sts: "2"
                },
                {
                    name: "已过期",
                    sts: "4"
                },
                {
                    name: "已使用",
                    sts: "6"
                }
            ]
        }
    },
    methods: {
        onLoad() {
            if (!this.loading) {
                this.loading = true; //证明正在加载中 阻断 调用onLoad
                this.getCardList(); //反向loading 没在加载中 可以进入
            }
        },
        orderListInit() {
            //获取所有订单
            this.getCardList();
        },
        async getCardList() {
            const hbscToken = this.$cookies.get("hbscToken") || sessionStorage.getItem('hbscToken') || '';
            const memberId = this.$cookies.get("memberId") || sessionStorage.getItem('memberId') || '';
            if (!hbscToken || !memberId) {
                this.complated = true;
                this.loading = false; //关闭加载
                return;
            }
            let params = {
                // token: "a756dd83d7fb496f84398003ad031361",
                type: 2,
                // sts: type,
                pageNum: this.pageNum,
                pageSize: "10"
            }
            if (this.type != 0) {
                params.sts = this.type
            }

            let res = await getUserPointCard(params)
            if (res.code == "0000") {
                if (res.data.list == "") {
                    this.cardList = [];
                    this.total = 0;
                    this.complated = true;
                    this.loading = false; //关闭加载
                } else {
                    if (res.data.pageNum != this.pageNum) { //返回的当前页与传入的当前页不符合 证明存在重复加载的嫌疑 
                        this.pageNum = res.data.pageNum + 1;
                        return false;
                    }
                    this.cardList = [];
                    this.cardList = this.cardList.concat(res.data.list); //拼接查询结果
                    this.total = res.data.total; //获取最大条数
                    if ((this.pageNum * params.pageSize) > res.data.total) { //如果当前页和每页显示条数大于total证明查询结果不够12条 显示没有更多 否则 不显示
                        this.complated = true;
                    } else {
                        this.complated = false;
                    }
                    this.pageNum = this.pageNum + 1; //当前页加一
                    this.loading = false; //关闭加载

                }
            } else {
                this.cardList = [];
                this.total = 0;
                this.complated = true;
                this.loading = false; //关闭加载
            }
        },
        submit(index) {
            this.$router.push({
                path: '/submitcardOrder',
                query: {
                    productList: encodeURIComponent(JSON.stringify(
                        [{
                            productList: [{
                                cardNo: this.cardList[index].cardNo, //积分卡号， 必
                                cardPassword: this.cardList[index].cardPassword,
                                productId: this.cardList[index].goodsId, //兑换产品ID， 必
                                productName: this.cardList[index].goodsName, //商品名称， 必
                            }]
                        }]
                    ))
                }
            })
        },
        tabGetList(name, title) {
            console.log(name, title)
            this.pageNum = 1;
            this.type = name;

            this.getCardList();

        },

    },
    mounted() {
        this.orderListInit()
    },
}
</script>

<style lang="scss" scoped>
.gopay {
    margin-right: 20px;

    width: 130px;
    height: 45px;
    line-height: 45px;
    background: $theme-color-main;
    color: white;
    border: 1px $theme-color-main solid;
    border-radius: 20px;
    text-align: center;
}

.container {
    background: #fff;
}

.cardlist {
    padding: 30px 0;
    margin-top: 20px;
    padding-left: 30px;
    border-bottom: 1px #eee solid;
    //  border-top: 1px gray solid;
}

.tit {
    padding-bottom: 30px;
    font-size: 28px;
}
</style>
